export interface IOtherAssets {
    plantandEquipment?: number | undefined;
    homeandContents?: number | undefined;
    savings?: number | undefined;
    superandShares?: number | undefined;
    other?: number | undefined;
}

export const initialOtherAssetsDetails: IOtherAssets = {};
